import Logo from "assets/logo-with-name.svg";
const PageNotFound = () => {
  return (
    <div className="flex flex-col h-screen w-full items-center justify-center bg-white">
      <div className="m-5">
        <img src={Logo} alt="Logo" />
      </div>
      <h1 className="text-2xl mt-10 font-black text-center">
        {" "}
        La page que vous cherchez n'existe pas!
      </h1>

      <a href="/" className="text-blue-900 mt-10">
        Revenir à l'acceuil
      </a>
    </div>
  );
};

export default PageNotFound;
